<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#4828a1">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status perubahan data menjadi <b class="font-weight-bold black--text">di{{ message.status }}</b> ?
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#6948c6"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <div class="color-dark-blue fs-22 font-weight-bold mb-6">
            Detail Perubahan Customer<span v-if="Object.keys(detail).length > 0">{{ detail.name }}</span>
          </div>

          <v-row
            class="mt-3">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  <v-row>
                    <v-col>
                      <div class="fs-18 mb-3 font-weight-bold input-label">
                        Presensi Masuk
                      </div>

                      <div>
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                          Nama Sales
                        </div>
                        <div class="fs-16 label-input">
                          {{ detail.sales_name }}
                        </div>
                      </div>

                      <div class="mt-4">
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                           Tanggal Masuk
                        </div>
                        <div class="fs-16 label-input">
                          {{ detail.start_datetime | datetime }}
                        </div>
                      </div>

                      <div class="mt-4">
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                          Lokasi Masuk
                        </div>
                        <div class="fs-16 label-input">
                          <a 
                          :href="`https://www.google.com/maps/search/?api=1&query=${detail.start_lat},${detail.start_long}`"
                          style="color:#0000FF;text-align:left" 
                          target="_blank">
                            <iframe 
                              width="100%" 
                              height="170" 
                              frameborder="0" 
                              scrolling="no" 
                              marginheight="0" 
                              marginwidth="0" 
                              :src="`https://maps.google.com/maps?q=${detail.start_lat},${detail.start_long}&hl=es&z=14&amp;output=embed`"
                              >
                            </iframe>
                          </a>
                        </div>
                      </div>

                      <div>
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                          Deskrpsi Masuk
                        </div>
                        <div class="fs-16 label-input">
                          {{ detail.desc_masuk }}
                        </div>
                      </div>

                      <div class="mt-4">
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                          Foto Masuk
                        </div>
                        <div class="fs-16 label-input">
                          <v-img
                            :src="detail.start_image"
                            contain
                            class="border-radius"
                            style="width: 100%; height: 150px;"
                          ></v-img>
                        </div>
                      </div>


                      
                    </v-col>
                    <v-col style="border-left: 1px solid #E7E7E7;">
                      <div class="fs-18 mb-3 font-weight-bold input-label">
                        Presensi Pulang
                      </div>

                      <div>
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                          Nama Sales
                        </div>
                        <div class="fs-16 label-input">
                          {{ detail.sales_name }}
                        </div>
                      </div>

                      <div class="mt-4">
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                           Tanggal Pulang
                        </div>
                        <div class="fs-16 label-input">
                          <span v-if="detail.end_datetime === ''">
                            -
                          </span>
                          <span v-else>
                            {{ detail.end_datetime | datetime }}
                          </span>
                        </div>
                      </div>

                      <div class="mt-4">
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                          Lokasi Pulang
                        </div>
                        <div class="fs-16 label-input">
                          <span v-if="detail.end_lat === ''">
                            -
                          </span>
                          <a 
                            v-else
                          :href="`https://www.google.com/maps/search/?api=1&query=${detail.end_lat},${detail.end_long}`"
                          style="color:#0000FF;text-align:left" 
                          target="_blank">
                            <iframe 
                              width="100%" 
                              height="170" 
                              frameborder="0" 
                              scrolling="no" 
                              marginheight="0" 
                              marginwidth="0" 
                              :src="`https://maps.google.com/maps?q=${detail.end_lat},${detail.end_long}&hl=es&z=14&amp;output=embed`"
                              >
                            </iframe>
                          </a>
                        </div>
                      </div>

                      <div>
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                          Deskrpsi Pulang
                        </div>
                        <div class="fs-16 label-input">
                          {{ detail.desc_pulang === '' ? '-' : detail.desc_pulang }}
                        </div>
                      </div>

                      <div class="mt-4">
                        <div 
                          class="fs-14">
                          <!-- <span class="red--text">*</span> -->
                          Foto Pulang
                        </div>
                        <div class="fs-16 label-input">
                          <span v-if="detail.end_image === ''">
                            -
                          </span>
                          <v-img
                            v-else
                            :src="detail.end_image"
                            contain
                            class="border-radius"
                            style="width: 100%; height: 150px;"
                          ></v-img>
                        </div>
                      </div>
                      
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              
              <v-btn
                to="/presensi/data"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false
        },

        detail: {},

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/presensi/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data[0]
          }
          this.process.load = false
        })
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async save () {
        this.message.error = ''

        this.process.form = true

        await post(`admin/customer_edit/approval`, {
          data: {
            edit_id: this.detail.id,
            status: this.message.status === 'terima' ? 'approved' : 'rejected'
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>